import React from 'react';
import { Alert, Box, Stack, Typography } from '@mui/material';
import { useAskAIContext } from '@/context/AskAiContext';
import DialogHeader from '../DialogHeader';
import FooterActions from '../FooterActions';
import MessagesContainer from '../MessagesContainer';
import AskAiTextfield from '../AskAiTextfield';
import AskAiHeader from '../AskAiHeader';
import AskAiAttachFromFolioButton from '../AskAiAttachFromFolioButton';
import AskAiSelectFilesDialog from '../AskAiSelectFilesDialog';

const AskAiInputArea = () => (
	<Stack spacing={1}>
		<AskAiAttachFromFolioButton />
		<AskAiTextfield />
	</Stack>
);

const DialogContent = () => {
	const { session, contextLoading, messages } = useAskAIContext();
	const hasMessages = messages.length > 0;

	return (
		<>
			<DialogHeader />
			<Box sx={{ p: 0, overflow: 'hidden', flex: 1, minHeight: 0 }}>
				<Box
					sx={{
						display: 'flex',
						flexDirection: 'column',
						height: '100%',
						minHeight: 0,
						px: { xs: 2, md: 2.75 },
						py: 1,
						gap: 1.75,
					}}
				>
					{contextLoading && (
						<Typography
							sx={(theme) => ({
								fontSize: '0.9rem',
								color: theme.palette.folioPurple,
								fontWeight: 500,
							})}
						>
							Loading notes, policies and correspondence for this context...
						</Typography>
					)}

					{session?.disabledReason && (
						<Alert severity='warning' sx={{ borderRadius: 3 }}>
							{session.disabledReason}
						</Alert>
					)}

					<Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
						{hasMessages ? (
							<Box
								sx={{
									flex: 1,
									minHeight: 0,
									overflowY: 'auto',
									pr: 0.75,
									py: 0.75,
									scrollBehavior: 'smooth',
								}}
							>
								<MessagesContainer />
								<Box sx={{ mt: 2 }}>
									<AskAiInputArea />
								</Box>
							</Box>
						) : (
							<Box
								sx={{
									flex: 1,
									minHeight: 0,
									display: 'flex',
									flexDirection: 'column',
								}}
							>
								<Box
									sx={{
										flex: 1,
										minHeight: 0,
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
									}}
								>
									<AskAiHeader />
								</Box>
								<AskAiInputArea />
							</Box>
						)}
					</Box>
				</Box>
			</Box>
			<FooterActions />
			<AskAiSelectFilesDialog />
		</>
	);
};
export default DialogContent;
